import { render, staticRenderFns } from "./LdmtApprovalStatus.vue?vue&type=template&id=896673fc&scoped=true"
import script from "./LdmtApprovalStatus.vue?vue&type=script&lang=js"
export * from "./LdmtApprovalStatus.vue?vue&type=script&lang=js"
import style0 from "./LdmtApprovalStatus.vue?vue&type=style&index=0&id=896673fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896673fc",
  null
  
)

export default component.exports